export default "__VITE_ASSET__85CJHB4i__"